var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticClass: "table table-striped table-hover table-sm" },
    [
      _c(
        "tbody",
        [
          _vm._l(_vm.itemInformation, function(itemDataAccessor) {
            return [
              _vm.isCheckedAndNotEmpty(itemDataAccessor)
                ? _c("tr", [
                    _c(
                      "td",
                      {
                        class: _vm.paddingClasses,
                        style: _vm.paddingInlineStyles
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.getTranslation(itemDataAccessor)) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        class: _vm.paddingClasses,
                        style: _vm.paddingInlineStyles
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.getFieldValue(itemDataAccessor)) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }